// APP CONFIG
export const $themeConfig = {
  lang: "fr", // en, de, es, fr
  theme: "light", // light, dark, system
  navigation: "vertical", // vertical, collapsible-vertical, horizontal
  layout: "full", // full, boxed-layout, large-boxed-layout
};
